// node_modules
import { FC, useContext } from "react";
import { CaseActionTypeEnum } from "Enums";
import { ICaseSelectedConcept } from "Interfaces/CaseActions/ICaseSelectedConcept";
import { CaseContext } from "Stores";
// Types
import { TConcept } from "Types/TConcept";
// Child components
import { TechnologyListItem } from "Components/Case/Results/ConceptTechnologyList/TechnologyListItem/TechnologyListItem";
import { AddTechnologyListItem } from "../AddTechnologyListItem";
import { DeliveryLayoutContext } from "Providers";

// styles
import styles from "./conceptListItem.module.scss";

type TConceptListItemProps = {
    concept: TConcept,
    doEnableAddingTechnologies?: boolean
};

export const ConceptListItem: FC<TConceptListItemProps> = ({ concept, doEnableAddingTechnologies } : TConceptListItemProps) => {
    
    // Shared context
    const { caseState, caseDispatch } = useContext(CaseContext);
    const { resetScrollCurrentMainScrolledContainer } = useContext(DeliveryLayoutContext);

    const getClassName = (): string => {
        const classNameList = [styles.conceptListItem];
        if(caseState.selectedConceptId && caseState.selectedConceptId === concept.id) classNameList.push(styles.active);
        const className = classNameList.join(" ");                
        return className;
    };

    const handleConceptClick = (): void => {
        resetScrollCurrentMainScrolledContainer();
        caseDispatch({ type: CaseActionTypeEnum.SetCaseSelectedConcept, selectedConceptId: concept.id, 
            selectedEntityName: concept.name, selectedEntityNumbering: concept.numbering } as ICaseSelectedConcept);
    };
    
    return (
        <>
            <div className={getClassName()} onClick={handleConceptClick} title={concept.name}>
                <span>{concept.numbering} {concept.name}</span>
            </div>
            {
                concept.technologies.map((currentTechnology) => {
                    return(<TechnologyListItem key={currentTechnology.id} technology={currentTechnology} />);
                })
            }
            { doEnableAddingTechnologies ? 
                <AddTechnologyListItem conceptNumbering={concept.numbering} />
                : null
            }
        </>
    );
};